export default __webpack_public_path__ + "media/zurb/img/events/soapbox/katiedill-0a0db2b3cf18889bac226b0bf7020981.png";